import { delayOffset, intersectionWatcher } from "@/lib/animation";

const selectors = {
  image: ".animation--image",
  imageOverlay: ".animation--image-overlay",
  content: ".animation--container > *",
  description: ".animation--item",
};

export default node => {
  // Add the animation delay offset variables
  delayOffset(node, [
    selectors.image,
    selectors.imageOverlay,
    selectors.content,
    selectors.description,
  ]);

  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
